import React from 'react';
import { Descriptions, Tag } from 'antd';
import { DeliveryCollectionSummaryData } from '../../Types/RouteDetails.types';

const VALUE_TYPE_CONFIG: Record<string, { color: string; tagColor: string; label: string }> = {
  cash: { color: '#52c41a', tagColor: 'green', label: 'Cash' },
  cheque: { color: '#fa8c16', tagColor: 'orange', label: 'Cheque' },
  unit: { color: '#1890ff', tagColor: 'blue', label: 'Units' },
  card: { color: '#1890ff', tagColor: 'blue', label: 'Card' },
};

const FINANCIAL_TYPES = ['cash', 'cheque'];

const isFinancialType = (type: string): boolean => FINANCIAL_TYPES.some((t) => type.toLowerCase().includes(t));

const getTypeConfig = (type: string) =>
  VALUE_TYPE_CONFIG[type.toLowerCase()] ?? {
    color: '#888',
    tagColor: 'default',
    label: type.charAt(0).toUpperCase() + type.slice(1),
  };

interface DeliveryCollectionSummaryProps {
  summary: DeliveryCollectionSummaryData;
}

const DeliveryCollectionSummary = ({ summary }: DeliveryCollectionSummaryProps): JSX.Element => {
  const activeTypes = Object.entries(summary.collectionByType).filter(([, amount]) => amount > 0);

  return (
    <Descriptions title="Delivery Collection Summary" bordered column={3} style={{ marginTop: 16 }}>
      <Descriptions.Item label="Total Delivery Value" span={1}>
        <span>{summary.totalValue.toFixed(2)}</span>
      </Descriptions.Item>

      <Descriptions.Item label="Remaining Value" span={2}>
        <span>{summary.remaining.toFixed(2)}</span>
      </Descriptions.Item>

      <Descriptions.Item label="Total Delivery Return" span={1}>
        <span style={{ color: '#f5222d' }}>{summary.totalDeliveryReturn.toFixed(2)}</span>
      </Descriptions.Item>

      <Descriptions.Item label="Total Collected" span={activeTypes.length === 1 ? 1 : 3}>
        <span style={{ color: '#1890ff' }}>{summary.totalDelivered.toFixed(2)}</span>
      </Descriptions.Item>

      {activeTypes.map(([type, amount]) => {
        const cfg = getTypeConfig(type);
        const isUnit = !isFinancialType(type);
        return (
          <Descriptions.Item
            key={type}
            label={
              <span>
                <Tag color={cfg.tagColor} style={{ marginRight: 4 }}>
                  {cfg.label}
                </Tag>
                {isUnit ? 'Delivered' : 'Collected'}
              </span>
            }
            span={1}
          >
            <span style={{ color: cfg.color }}>{amount.toFixed(2)}</span>
          </Descriptions.Item>
        );
      })}
    </Descriptions>
  );
};

export default DeliveryCollectionSummary;
